import { useTranslation } from "react-i18next";
import { useInstallPrompt } from "../../pwa/useInstallPrompt";

function useIsMobile(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(max-width: 768px)").matches;
}

export function InstallPromptBanner() {
  const { t } = useTranslation("pwa");
  const isMobile = useIsMobile();
  const { canPrompt, promptInstall, dismiss } = useInstallPrompt();

  if (!isMobile || !canPrompt) return null;

  return (
    <div
      role="banner"
      aria-label={t("install_prompt.title")}
      className="fixed bottom-0 start-0 end-0 z-50 flex items-center justify-between gap-3 border-t border-border bg-background px-4 py-3 shadow-lg"
    >
      <div className="flex min-w-0 flex-col">
        <span className="text-sm font-semibold text-foreground">
          {t("install_prompt.title")}
        </span>
        <span className="text-xs text-muted-foreground">
          {t("install_prompt.description")}
        </span>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <button
          type="button"
          onClick={dismiss}
          className="min-h-[44px] rounded-md px-3 py-2 text-sm text-muted-foreground hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {t("install_prompt.cta_dismiss")}
        </button>
        <button
          type="button"
          onClick={promptInstall}
          className="min-h-[44px] rounded-md bg-primary px-3 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {t("install_prompt.cta_install")}
        </button>
      </div>
    </div>
  );
}
